import { render, staticRenderFns } from "./ProductSlider.vue?vue&type=template&id=024d20ee&scoped=true&"
import script from "./ProductSlider.vue?vue&type=script&lang=js&"
export * from "./ProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductSlider.vue?vue&type=style&index=0&id=024d20ee&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d20ee",
  null
  
)

export default component.exports